<template>
  <section :class="[{'mh-treeMenu': true}, theme]">
      <MenuItem
        v-for="(item, index) in menuItems"
        :key="index"
        :item="item"
        :on-select="onSelect"
      >
        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
      </MenuItem>
  </section>
</template>

<script>
import MenuItem from "./MenuItem";
export default {
  name: "TreeMenu",
  components: { MenuItem },
  props: {
    theme: {
      type: String,
      default: function () {
        return "theme-default"
      },
      required: false
    },
    menuItems: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSelect(node){
      this.$emit("select", node);
    }
  }
};
</script>

<style scoped>
.mh-treeMenu {
  width: 100%;
  padding: 0.5rem;
  box-sizing: border-box;
}
</style>
